export function downloadBlob(blob: Blob, filename: string): void {
  const url = URL.createObjectURL(blob);
  const a = document.createElement('a'); a.href = url; a.download = filename; document.body.appendChild(a); a.click(); a.remove();
  setTimeout(() => URL.revokeObjectURL(url), 10_000);
}

/** Renders a caught export failure (worker rejection, Comlink transport error, etc.) as a user-facing message. */
export function formatExportError(err: unknown): string {
  return err instanceof Error ? err.message : String(err);
}
